/**
 * 品目マスタ
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/items`

const item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },

    /**
     * JWNET取扱品目一覧取得
     * @param param0
     * @param param0.commit
     * @param param1
     * @param param1.type { String } 品目種別
     *  industrial: 産業廃棄物
     *  specific_industrial: 特定産業廃棄物
     *  general: 一般廃棄物
     * @return {Promise<unknown>}
     */
    fetchBy ({commit}, { type = 'industrial' }) {
      const params = { type: type }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    fetchAll () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {},
}

export default item

